
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.898.625l2.305 6.172 6.172 2.344c.39.117.625.468.625.859 0 .39-.234.742-.586.86l-6.21 2.343-2.306 6.172A.963.963 0 0110 20c-.39 0-.742-.234-.86-.586l-2.343-6.21-6.172-2.306A.963.963 0 010 10c0-.39.234-.742.625-.86l6.172-2.343L9.14.625A.879.879 0 0110 0c.39 0 .742.234.898.625z","fill":"currentColor"}})])
          )
        }
      }
    